<div cdkDrag cdkDragRootElement=".cdk-overlay-pane">
    <div mat-dialog-title class="matDialogTitle" cdkDragHandle>
        <mat-progress-bar mode="indeterminate" class="detaile" [hidden]="!loading"></mat-progress-bar>
        کالا
        <span class="close" (click)="close()">
            <mat-icon>close</mat-icon>
        </span>
    </div>
</div>


<div mat-dialog-content class="matDialogContent">
    <div style="text-align: right;">
        <span>
            <button (click)="which(2)" [disabled]='next_status'><i class="fas fa-forward"></i></button>
            <button (click)="which(3)" [disabled]='pre_status'><i class="fas fa-backward"></i></button>
        </span>

        <button type="button" class="search_button" *ngFor="let x of list_material_type"
            (click)="get(1,1,x.wharehouse_material_type_id)"
            [ngClass]="{active1:x.wharehouse_material_type_id == material_type}"
            [hidden]="x.wharehouse_material_type_id == 2 && ref == 'order' ">
            {{ x.wharehouse_material_type_title }}
        </button>
        <button type="button" class="search_button" (click)="get_exit(1,1)"
            [ngClass]="{active1:material_type == 0}">مصرف شده</button>
        <button type="button" class="search_button" (click)="add()" style="float:left" *ngIf="material_type == 1"
            [hidden]="true">درج
            قطعات جدید</button>
    </div>
    <input class="search" (keyup)="get_search()" [(ngModel)]="search" autocomplete="off">
    <div class="content-body control-content-body" [ngClass]="{content_body_en:lang==2}"
        style='overflow-x:auto;direction:rtl;max-height:22rem;min-height:1rem'>
        <mat-table [dataSource]="dataSource" style='min-width:100%'
            class='table-scroll mat_table_fa_without_scroll mat_table_fa_without_scroll_bg not- pe1'
            [ngClass]="{mat_table_en_without_scroll:lang==2,en1:lang == 2}"
            [ngStyle]="{'direction': lang == 2 ? 'ltr' : 'rtl' }" [hidden]="material_type != 1">
            <ng-container matColumnDef="row">
                <mat-header-cell *matHeaderCellDef style="max-width:30px">
                    #
                </mat-header-cell>
                <mat-cell *matCellDef="let x;let i = index" style="max-width:30px">{{ i + page_number_first }}
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="material">
                <mat-header-cell *matHeaderCellDef style="text-align: center !important;" class="right">
                    <span *ngIf="lang == 1">عنوان قطعه</span>
                    <span *ngIf="lang == 2">Material Name</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let x" class="cursor right">
                    <span class="paddingRight">{{ x.wharehouse_material_title }}</span>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="cate">
                <mat-header-cell *matHeaderCellDef style="max-width:150px">
                    <span *ngIf="lang == 1">دسته</span>
                    <span *ngIf="lang == 2">Cate</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let x" class="cursor" style="text-align: center;max-width:150px">
                    <div class="right">{{ x.wharehouse_material_cate_title }}</div>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="inventory">
                <mat-header-cell *matHeaderCellDef style="max-width:80px">
                    <span *ngIf="lang == 1">موجودی</span>
                    <span *ngIf="lang == 2">Inventory</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let x" class="cursor" style="text-align: center;" style="max-width:80px">
                    {{ x.inventory }}
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="order">
                <mat-header-cell *matHeaderCellDef style="max-width:90px" [hidden]='true'>
                    <span *ngIf="lang == 1">ش درخواست</span>
                    <span *ngIf="lang == 2">Order id</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let x" class="cursor" style="text-align: center;"
                    style="max-width:90px;padding:0px !important" [hidden]='true'>
                    <input class=" wh-input input1" id="order1{{ x.wharehouse_material_id }}" autocomplete="off"
                        (click)="select_material(x.wharehouse_material_id,false)" readonly>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="invoice">
                <mat-header-cell *matHeaderCellDef style="max-width:90px">
                    <span *ngIf="lang == 1">ش فاکتور خرید</span>
                    <span *ngIf="lang == 2">Inventory</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let x" class="cursor" style="text-align: center;" style="max-width:90px"
                    (click)="select_material(x.wharehouse_material_id,false)">
                    <span id="invoice1{{ x.wharehouse_material_id }}">
                        <mat-icon class="add_circle_outline" style="vertical-align: middle;font-size: 20px;">
                            add_circle_outline
                        </mat-icon>
                    </span>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="invoice_price">
                <mat-header-cell *matHeaderCellDef style="max-width:90px">
                    <span *ngIf="lang == 1">قیمت خرید</span>
                    <span *ngIf="lang == 2">Inventory</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let x" class="cursor" style="text-align: center;" style="max-width:90px"
                    id="invoice_price1{{ x.wharehouse_material_id }}">
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="number">
                <mat-header-cell *matHeaderCellDef style="max-width:80px">
                    <span *ngIf="lang == 1">تعداد </span>
                    <span *ngIf="lang == 2">Inventory</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let x" class="cursor" style="text-align: center;"
                    style="max-width:80px;padding:0px !important">
                    <input class=" wh-input input1" id="input1{{ x.wharehouse_material_id }}" [value]="1"
                        autocomplete="off">
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="cost">
                <mat-header-cell *matHeaderCellDef style="max-width:80px" [hidden]="ref == 'order' ">
                    <span *ngIf="lang == 1">قیمت فروش</span>
                    <span *ngIf="lang == 2">Inventory</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let x" class="cursor" style="text-align: center;"
                    style="max-width:80px;padding:0px !important" [hidden]="ref == 'order' ">
                    <input class="wh-input input1" id="cost1{{ x.wharehouse_material_id }}" autocomplete="off"
                        [value]="x.wharehouse_material_price2 | number">
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="add">
                <mat-header-cell *matHeaderCellDef style="max-width:80px">
                    <span *ngIf="lang == 1">اضافه کردن</span>
                    <span *ngIf="lang == 2">Inventory</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let x;let i = index" class="cursor" style="text-align: center;"
                    style="max-width:80px;padding-top:3px !important">
                    <mat-icon class="add_circle_outline" (click)="save(i,x.wharehouse_material_id , 1 , 1 , 0)"
                        style="vertical-align: middle;font-size: 20px;">
                        add_circle_outline
                    </mat-icon>
                </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns" color="primary"></mat-header-row>
            <mat-row *matRowDef="let x;let i = index;columns:displayedColumns"></mat-row>
        </mat-table>
        <!-- ******************************************************************************************************************-->
        <mat-table [dataSource]="dataSource" style='min-width:100%' class='table-scroll mat_table_fa_without_scroll pe1'
            [ngClass]="{mat_table_en_without_scroll:lang==2,en1:lang == 2}"
            [ngStyle]="{'direction': lang == 2 ? 'ltr' : 'rtl' }" *ngIf="material_type == 0">
            <ng-container matColumnDef="row">
                <mat-header-cell *matHeaderCellDef style='max-width:40px'>
                    <span *ngIf="lang == 1">ردیف</span>
                    <span *ngIf="lang == 2">#</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let x;let i = index" style='max-width:40px'>{{ i + 1 }}</mat-cell>
                <mat-footer-cell *matFooterCellDef style='max-width:40px'></mat-footer-cell>
            </ng-container>

            <ng-container matColumnDef="type">
                <mat-header-cell *matHeaderCellDef style="max-width:70px">
                    <span *ngIf="lang == 1">نوع</span>
                    <span *ngIf="lang == 2">Category</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let x;let i = index"
                    (click)="open_detaile_exit(i,2,x.wharehouse_order_id,x.title,x.footer,x.wharehouse_order_material_type,x.wharehouse_order_repairman)"
                    style="max-width:70px">
                    {{ x.wharehouse_material_type_title }}</mat-cell>
                <mat-footer-cell *matFooterCellDef style="max-width:70px"></mat-footer-cell>
            </ng-container>

            <ng-container matColumnDef="material">
                <mat-header-cell *matHeaderCellDef>
                    <span *ngIf="lang == 1">عنوان کالا</span>
                    <span *ngIf="lang == 2">Order Title</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let x;let i = index"
                    (click)="open_detaile_exit(i,2,x.wharehouse_order_id,x.title,x.footer,x.wharehouse_order_material_type,x.wharehouse_order_repairman)">
                    <span>{{ x.title }}</span>
                </mat-cell>
                <mat-footer-cell *matFooterCellDef></mat-footer-cell>
            </ng-container>

            <ng-container matColumnDef="cate">
                <mat-header-cell *matHeaderCellDef style="max-width:150px">
                    <span *ngIf="lang == 1">دسته</span>
                    <span *ngIf="lang == 2">Category</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let x;let i = index"
                    (click)="open_detaile_exit(i,2,x.wharehouse_order_id,x.title,x.footer,x.wharehouse_order_material_type,x.wharehouse_order_repairman)"
                    style="max-width:150px">
                    {{ x.wharehouse_material_cate_title }}</mat-cell>
                <mat-footer-cell *matFooterCellDef style="max-width:150px"></mat-footer-cell>
            </ng-container>

            <ng-container matColumnDef="number">
                <mat-header-cell *matHeaderCellDef style="max-width:100px">
                    <span *ngIf="lang == 1">تعداد</span>
                    <span *ngIf="lang == 2">Number</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let x;let i = index"
                    (click)="open_detaile_exit(i,2,x.wharehouse_order_id,x.title,x.footer,x.wharehouse_order_material_type,x.wharehouse_order_repairman)"
                    style="max-width:100px">
                    {{ x.wharehouse_order_number | number }}</mat-cell>
                <mat-footer-cell *matFooterCellDef style="max-width:100px"></mat-footer-cell>
            </ng-container>

            <ng-container matColumnDef="cost">
                <mat-header-cell *matHeaderCellDef style="max-width:100px">
                    <span *ngIf="lang == 1">قیمت</span>
                    <span *ngIf="lang == 2">Cost</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let x;let i = index"
                    (click)="open_detaile_exit(i,2,x.wharehouse_order_id,x.title,x.footer,x.wharehouse_order_material_type,x.wharehouse_order_repairman)"
                    style="max-width:100px">
                    {{ x.cost | number }}</mat-cell>
                <mat-footer-cell *matFooterCellDef style="max-width:100px"></mat-footer-cell>
            </ng-container>

            <ng-container matColumnDef="sum">
                <mat-header-cell *matHeaderCellDef style="max-width:100px">
                    <span *ngIf="lang == 1">جمع</span>
                    <span *ngIf="lang == 2">Sum</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let x;let i = index"
                    (click)="open_detaile_exit(i,2,x.wharehouse_order_id,x.title,x.footer,x.wharehouse_order_material_type,x.wharehouse_order_repairman)"
                    style="max-width:100px">
                    {{ x.sum | number }}</mat-cell>
                <mat-footer-cell *matFooterCellDef style="max-width:100px">
                    {{ sum_all | number }}
                </mat-footer-cell>
            </ng-container>

            <ng-container matColumnDef="operation">
                <mat-header-cell *matHeaderCellDef style='max-width:100px'>
                    <span *ngIf="lang == 1"> عملیات </span>
                    <span *ngIf="lang == 2">Operation</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let x;let i = index" style='max-width:100px'>
                    <span
                        (click)='open_detaile_exit(i,2,x.wharehouse_order_id,x.title,x.footer,x.wharehouse_order_material_type,x.wharehouse_order_repairman)'><i
                            class="fas fa-desktop icon"></i></span>
                    <span (click)="delete_exit(x.wharehouse_order_id,x.wharehouse_order_repairman)"><i
                            class="far fa-trash-alt icon" style='margin:0px 4px;'></i></span>
                </mat-cell>
                <mat-footer-cell *matFooterCellDef style="max-width:100px"></mat-footer-cell>
            </ng-container>

            <mat-header-row class="mat-header-row-dialog" *matHeaderRowDef="displayedColumns3" color="primary">
            </mat-header-row>
            <mat-row class="mat-header-row-dialog" *matRowDef="let row;columns:displayedColumns3;let i = index"
                (click)="mat_table_selectedRow = row" (mouseenter)="mat_table_hoverRow = row"
                [ngClass]="{'mat_table_selected': row === mat_table_selectedRow,mat_table_selected2:row.checked == true,'mat_table_hover': row === mat_table_hoverRow}"
                class="cursor"></mat-row>
            <mat-footer-row *matFooterRowDef="displayedColumns3"></mat-footer-row>
        </mat-table>
    </div>
    <!-- **************************************************************************************************** -->
</div>